import { useContext } from "react"
import { RouterProvider } from "react-router-dom"
import { authContext } from "../Context/authContext"
import router from "../router"
import Login from "./Login"
import {
  TransitionGroup,
  CSSTransition
} from "react-transition-group";

export default function LayoutControl(){
    const {token} = useContext(authContext)
    return (
        <TransitionGroup>
          <CSSTransition
            key={token}
            classNames="fade"
            timeout={500}
            exit={false}
          >
            {token ? <RouterProvider router={router} /> : <Login />}
          </CSSTransition>
        </TransitionGroup>
    )
}